export default {
  show({ commit }, values) {
    commit('show', values);
  },
  hide({ commit }) {
    commit('hide');
  },
};
